<div fxLayout="column" fxLayoutAlign="center center">
  <div class="next-steps">
    <h1>Discipleship Path <strong>PRAYING</strong> Next Steps</h1>
    <p>With respect to <strong>PRAYING</strong>, below are considerations to enhance your spiritual walk in Christ.
      "But Jesus Himself would often slip away to the wilderness to pray" Luke 5:16</p>
  </div>
  <hr class="divider" />
  <div class="exploring-christ">
    <h2>Exploring Christ</h2>
    <h3 class="mat-h3">What</h3>
    <p><strong>PRAYER</strong> is a conversation with God. It is words spoken from your heart to God's.</p>
    <h3 class="mat-h3">Where and When</h3>
    <p>Dedicate a daily time and place to <strong>PRAY</strong>.</p>
    <h3 class="mat-h3">How to Pray</h3>
    <p><strong><u>P</u></strong>raise</p>
    <p><strong><u>R</u></strong>epent</p>
    <p><strong><u>A</u></strong>sk for others</p>
    <p><strong><u>Y</u></strong>our own needs</p>
    <h3 class="mat-h3">How to Pray</h3>
    <p>Why Pray</p>
    <p>To grow closer to God.</p>
    <h3 class="mat-h3">Expect to meet the Lord in <strong>PRAYER</strong>!</h3>
  </div>
  <div class="growing-in-christ">
    <h2>Growing In Christ</h2>
    <ul>
      <li>Choose a mentor or accountability partner to keep your promise of <strong>PRAYER</strong></li>
      <li>Start a <strong>PRAYER</strong> journal to document all the ways God is moving. Be certain to include
        <strong>PRAYERS</strong> of gratitude.
      </li>
      <li>Set a goal or have a vision to measure spiritual progress.</li>
      <li><strong>PRAY</strong> in the Spirit<a href="https://biblia.com/bible/esv/jude/1/20" target="_blank"> [Jude
          1:20]</a>
      </li>
    </ul>
  </div>
  <div class="close-to-christ">
    <h2>Close To Christ</h2>
    <ul>
      <li><strong>PRAY</strong> with others<a href="https://biblia.com/bible/esv/matthew/18/20" target="_blank">
          [Matthew 18:20]</a>
      </li>
      <li><strong>PRAY</strong> for others<a href="https://biblia.com/bible/esv/james/5/16" target="_blank">
          [James 5:16]</a>
      </li>
      <li><strong>PRAY</strong> bold <strong>PRAYERS</strong> and <strong>PRAY</strong> with expectancy!
    </li>
    </ul>
  </div>
  <div class="christ-centered">
    <h2>Christ-Centered</h2>
    <ul>
      <li><strong>PRAY</strong> with fasting as a means of denying the flesh by feeding only the spirit.</li>
      <li>Minister to others through <strong>PRAYER</strong>. Examples include rebuking illness, breaking strongholds, evangelizing to the lost.</li>
      <li>Listen for the nudging/voice of the Holy Spirit during <strong>PRAYER</strong>. Trust it by taking obedient action.</li>
    </ul>
  </div>
</div>